<div class="media-selector-container flex flex-col gap-1">
    <p>Choose or upload image</p>
    <p-select-button [options]="viewOptions" [(ngModel)]="view" optionLabel="label" optionValue="value"
                     aria-labelledby="basic"/>
    @if (view === 'select') {
        <p-select
                [(ngModel)]="selectedMediaPreview"
                [options]="mediaOptions"
                [virtualScroll]="true"
                [virtualScrollItemSize]="48"
                [filter]="true"
                [showClear]="true"
                (ngModelChange)="onMediaPreviewSelected($event)"
                placeholder="Select Media"
                optionLabel="filename"
                appendTo="body"
                class="w-full"
        >
            <!-- Template for Selected Media -->
            <ng-template #selectedItem let-selectedOption>
                <div class="flex items-center gap-2">
                    <img
                            [src]="selectedOption.cloudfrontUrl"
                            alt="media image"
                            style="width: 32px; height: 32px; object-fit: cover;"
                    />
                    <div>{{ selectedOption.filename }}</div>
                </div>
            </ng-template>
            <!-- Template for Media Items -->
            <ng-template #item let-media>
                <div class="flex items-center gap-2">
                    <img
                            [src]="media.cloudfrontUrl"
                            alt="media image"
                            style="width: 32px; height: 32px; object-fit: cover;"
                    />
                    <div>{{ media.filename }}</div>
                </div>
            </ng-template>
        </p-select>
    }
    @if (view === 'upload') {
        @if (!this.waiting) {
            <app-upload-media (uploadSuccess)="onUploadSuccess($event)"></app-upload-media>
        }
        @if (this.waiting) {
            <p-progressSpinner></p-progressSpinner>
        }
    }
</div>
